module.exports = __webpack_public_path__ + "static/media/Zengta.4b0cb6de.webp";